import Axios from 'axios'
import { memberUrls } from '../MemberService/urls'
import { volunteerUrls } from '../VolunteerService/urls'
import { donationUrls } from '../DonationService/urls'
import { bookingReportUrls } from '../BookingService/urls'
export default {
  get_members_revenue_chart (context) {
    Axios.get(memberUrls.fetchMembersRevenueData).then((response) => {
      context.commit('MEMBER_REVENUE_DATA', response.data)
    })
  },
  get_volunteers_revenue_chart (context) {
    Axios.get(volunteerUrls.fetchVolunteerRevenueData).then((response) => {
      context.commit('VOLUNTEER_REVENUE_DATA', response.data)
    })
  },
  get_donations_revenue_chart (context) {
    Axios.get(donationUrls.fetchDonationsRevenueData).then((response) => {
      context.commit('DONATIONS_REVENUE_DATA', response.data)
    })
  },
  get_bookings_revenue_chart (context, data) {
    
    Axios.post(bookingReportUrls.generateBookingsRevenueData, data).then((response) => {
      context.commit('BOOKINGS_REVENUE_DATA', response.data)
    })
  },
  get_residency_revenue_chart (context, data) {
    Axios.post(bookingReportUrls.generateResidencyRevenueData, data).then((response) => {
      context.commit('RESIDENCY_REVENUE_DATA', response.data)
    })
  },
  get_vehicle_revenue_chart (context, data) {
    Axios.post(bookingReportUrls.generateVehicleRevenueData, data).then((response) => {
      context.commit('VEHICLE_REVENUE_DATA', response.data)
    })
  },
  get_inventory_revenue_chart (context, data) {
    Axios.post(bookingReportUrls.generateInventoryRevenueData, data).then((response) => {
      context.commit('INVENTORY_REVENUE_DATA', response.data)
    })
  },
  get_transactions_chart (context, data) {
    Axios.post(bookingReportUrls.generateTransactionsData, data).then((response) => {
      // console.log(response.data)
      context.commit('TRANSACTIONS_REPORT_DATA', response.data)
    })
  },
 
}
